import { IExperiment } from '../../types/experiments';

export function isAbUseExperimentActive(experiments: IExperiment[], experimentName: string, targetGroup: string) {
  const experiment = experiments.find(e => e.experimentName === experimentName);

  if (experiment) {
    return experiment.groupName === targetGroup;
  }

  return false;
}
